import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiCircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  rootSpacing: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
  },
  progress: {},
  progressColorGray: {
    color: theme.palette.facet.primaryGray,
  },
  progressColorWhite: {
    color: theme.palette.common.white,
  },
  progressColorPrimary: {
    color: theme.palette.primary.main,
  },
  alignCenter: {
    alignSelf: 'center',
  },
});

function LoadingIndicator({
  className, classes, color, size, spacing, align, loadingText,
}) {
  return (
    <div className={classNames(className, { [classes.rootSpacing]: spacing })}>
      <MuiCircularProgress
        className={classNames(classes.progress, {
          [classes.progressColorGray]: color === 'gray',
          [classes.progressColorWhite]: color === 'white',
          [classes.progressColorPrimary]: color === 'primary',
          [classes.alignCenter]: align === 'center',
        })}
        color="inherit"
        size={size}
      />
      {loadingText || null}
    </div>
  );
}

LoadingIndicator.defaultProps = {
  className: '',
  color: 'gray',
  size: 40, // mui default
  spacing: true,
  align: 'flex-start',
};

LoadingIndicator.propTypes = {
  spacing: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(['gray', 'white', 'primary']),
  size: PropTypes.number,
  align: PropTypes.string,
};

export default withStyles(styles)(LoadingIndicator);
